<template>
<tc-table class="tc-table mt-5" :dataList="visits" @filter="fetchDataWithFiltering" :tbody="tbody" :settings="{
      export: {
        show: true,
        handle: exportCsv
      },
      filters: {
        contactType: {
          type: 'v-select',
          class: 'min-w-48',
          label: 'Type',
          clearable: false,
          options: {
            text: 'name',
            value: 'id',
            items: [{
              id: '',
              name: 'All'
            }, ...((contactTypes || {}).items || [])]
          }
        }
      }
    }">
    <template slot="thead">
        <vs-th>Status</vs-th>
        <vs-th>Location</vs-th>
        <vs-th>Name</vs-th>
        <vs-th>Type</vs-th>
        <vs-th>Company</vs-th>
        <vs-th>Hosted By</vs-th>
        <vs-th>Sign in</vs-th>
        <vs-th>Sign out</vs-th>
    </template>
</tc-table>
</template>

<script>
import moment from 'moment';
import dashboardTableBody from '@/components/tc-toble-body/Dashboard.vue';
import {
    mapState
} from 'vuex';

export default {
    computed: {
        ...mapState('visitManagement', ['contactTypes', 'visits'])
    },
    data() {
        return {
            tbody: {
                component: dashboardTableBody,
                methods: {
                    signout: id => {
                        this.signoutVisit(id);
                    },
                    fetchDataWithFiltering: () => {
                        this.fetchDataWithFiltering();
                    }
                }
            },
            summaryData: {},
            locationId: null,
            tableVisitParams: {

            },
            defaultTableVisitParams: {
                orderby: 'latestActivity desc'
            }
        }
    },
    methods: {
        async signoutVisit(visitId) {
            const hasRelatedVisitsCheckoutTime = await this.checkRelatedVisitsCheckoutTime(visitId);
            const mainVisit = await this.fetchVisit(visitId);
            if (hasRelatedVisitsCheckoutTime.length > 0) {
                hasRelatedVisitsCheckoutTime.map(item => item.toCheckout = false);
                return this.$root.$tcPopup.show({
                    data: {
                        relatedVisits: hasRelatedVisitsCheckoutTime,
                        visit: mainVisit,
                        tableVisitParams: this.tableVisitParams,
                    },
                    classes: 'vs-dialog--md',
                    title: 'Checkout',
                    component: 'CheckoutVisit',
                    buttonsHidden: true
                })
            }
            await this.$store.dispatch('visitManagement/signoutVisit', {
                visitId: visitId,
                route: this.$route
            }).then(async res => {
                await this.fetchDataWithFiltering();
            })
        },
        async checkRelatedVisitsCheckoutTime (visitId) {
            const visit = await this.fetchVisit(visitId);
            const relatedVisits = (visit || {}).relatedVisits || [];
            const relatedVisitsLen = relatedVisits.length;
            if (relatedVisitsLen > 0) {
                const relatedVisitsCheckout = relatedVisits.filter(rv => rv.checkoutTime === null);
                return relatedVisitsCheckout;
            }

            return [];
        },
        async fetchVisit(visitId) {
            return await this.$store.dispatch('visitManagement/fetchVisit', { id: visitId });
        },
        formatData() {
            const me = this;
            if (me.summaryData) {
                this.$emit('load', me.summaryData);
            }
        },
        async fetchDataWithFiltering(params) {
            if (this.$route.name !== 'dashboard') return // prevent for now
            if (params) {
                this.tableVisitParams = {
                    ...params
                }
            }

            const me = this;
            if (me.locationId) {
                me.tableVisitParams['location.id'] = me.locationId;
            } else {
                delete me.tableVisitParams['location.id'];
            }

            //console.log('this.tableVisitParams', this.tableVisitParams);
            await this.$store
                .dispatch('visitManagement/fetchVisits', this.tableVisitParams)
                .catch(
                    response => {
                        console.log(response);
                    },
                    err => {
                        console.error(err);
                    }
                );

            const today = moment(Date.now()).format('YYYY-MM-DD');
            const dateParams = {};
            dateParams['activity.start.from'] = moment(`${today} 00:00`).utc().format();
            dateParams['activity.start.to'] = moment(`${today} 00:00`).add(1, 'day').utc().format();

            // console.log({tableVisitParams: this.tableVisitParams })

            if (this.tableVisitParams['location.id']) {
                dateParams['location.id'] = this.tableVisitParams['location.id'];
                this.$store
                    .dispatch('visitManagement/fetchLocationSummary', dateParams)
                    .then(function (res) {
                        me.summaryData = res.data;
                        me.formatData();
                    })
                    .catch(
                        response => {
                            console.log(response);
                        },
                        err => {
                            console.error(err);
                        }
                    );
            } else {
                this.$store
                    .dispatch('visitManagement/fetchLocationSummaryAll', dateParams)
                    .then(function (res) {
                        me.summaryData = res.data;
                        me.formatData();
                    })
                    .catch(
                        response => {
                            console.log(response);
                        },
                        err => {
                            console.error(err);
                        }
                    );
            }
        },
        exportCsv(params) {
            this.$store.dispatch('visitManagement/exportVisits', params);
        },
        async changeLocation(selectedLocation) {
            if (selectedLocation) {
                this.locationId = selectedLocation.id;
            } else {
                this.locationId = null;
            }
            return await this.fetchDataWithFiltering();
        }
    },
    async created() {
        await this.$store.dispatch('visitManagement/fetchContactTypes', {
            limit: 1000
        })
        console.log("this.visits >>> ", this.visits);
    }
}
</script>
